<wbo-search-page (prepareInitialFilter)="prepareInitialFilter()" [editRoute]="overrideEditRoute" [title]="maintenanceMode ? 'wbo.sales-maintenance.search.title' : undefined">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="invoiceNo">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="identifier">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="fromDate">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'toDate'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'employee'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'paymentType'">
                <wbo-single-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option value="Cheque"
                                           label="wbo.sales-journal.option.payment-type.cheque"></wbo-select-option>
                        <wbo-select-option value="Cash"
                                           label="wbo.sales-journal.option.payment-type.cash"></wbo-select-option>
                        <wbo-select-option value="Savings"
                                           label="wbo.sales-journal.option.payment-type.savings"></wbo-select-option>
                        <wbo-select-option value="Visa"
                                           label="wbo.sales-journal.option.payment-type.visa"></wbo-select-option>
                        <wbo-select-option value="MasterCard"
                                           label="wbo.sales-journal.option.payment-type.masterCard"></wbo-select-option>
                        <wbo-select-option value="American Express"
                                           label="wbo.sales-journal.option.payment-type.amex"></wbo-select-option>
                        <wbo-select-option value="BankCard"
                                           label="wbo.sales-journal.option.payment-type.bankCard"></wbo-select-option>
                        <wbo-select-option value="Diners Club"
                                           label="wbo.sales-journal.option.payment-type.dinersClub"></wbo-select-option>
                        <wbo-select-option value="JCB"
                                           label="wbo.sales-journal.option.payment-type.jcb"></wbo-select-option>
                        <wbo-select-option value="Web Payment"
                                           label="wbo.sales-journal.option.payment-type.web"></wbo-select-option>
                        <wbo-select-option value="Other"
                                           label="wbo.sales-journal.option.payment-type.otherCard"></wbo-select-option>
                        <wbo-select-option value="BarterCard"
                                           label="wbo.sales-journal.option.payment-type.barterCard"></wbo-select-option>
                        <wbo-select-option value="Bank Cheque"
                                           label="wbo.sales-journal.option.payment-type.bankCheque"></wbo-select-option>
                        <wbo-select-option value="EFT"
                                           label="wbo.sales-journal.option.payment-type.eft"></wbo-select-option>
                        <wbo-select-option value="Redemption"
                                           label="wbo.sales-journal.option.payment-type.redemption"></wbo-select-option>
                        <wbo-select-option value="Flexicash"
                                           label="wbo.sales-journal.option.payment-type.flexiCash"></wbo-select-option>
                        <wbo-select-option value="PayPal"
                                           label="wbo.sales-journal.option.payment-type.payPal"></wbo-select-option>
                        <wbo-select-option value="Room Charge"
                                           label="wbo.sales-journal.option.payment-type.roomCharge"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'type'">
                <wbo-single-select-search-control initialDefaultValue="Any">
                    <wbo-select-options>
                        <wbo-select-option [value]="'sale'"
                                           label="wbo.sales-journal.option.sale-type.sale"></wbo-select-option>
                        <wbo-select-option [value]="1"
                                           label="wbo.sales-journal.option.sale-type.tableSale"></wbo-select-option>
                        <wbo-select-option [value]="3"
                                           label="wbo.sales-journal.option.sale-type.tabSale"></wbo-select-option>
                        <wbo-select-option [value]="4"
                                           label="wbo.sales-journal.option.sale-type.refund"></wbo-select-option>
                        <wbo-select-option [value]="5"
                                           label="wbo.sales-journal.option.sale-type.outGoingSale"></wbo-select-option>
                        <wbo-select-option [value]="6"
                                           label="wbo.sales-journal.option.sale-type.deliverySale"></wbo-select-option>
                        <wbo-select-option [value]="7"
                                           label="wbo.sales-journal.option.sale-type.takeAwaySale"></wbo-select-option>
                        <wbo-select-option [value]="8"
                                           label="wbo.sales-journal.option.sale-type.driveThruSale"></wbo-select-option>
                        <wbo-select-option [value]="9"
                                           label="wbo.sales-journal.option.sale-type.cashOut"></wbo-select-option>
                        <wbo-select-option [value]="11"
                                           label="wbo.sales-journal.option.sale-type.tableApp"></wbo-select-option>
                        <wbo-select-option [value]="101"
                                           label="wbo.sales-journal.option.sale-type.layBy"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'terminal'">
                <wbo-terminal-multi-select-search-control></wbo-terminal-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'reference'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'integratedOrderId'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="invoiceNo"></wbo-main-search-column>
        <wbo-column field="orderNo"></wbo-column>
        <wbo-column field="orderName"></wbo-column>
        <wbo-column field="customerName"></wbo-column>
        <wbo-column field="customerRefNo" [hideable]="true" [enabled]="false"></wbo-column>
        <wbo-url-link-column field="integratedDeliveryId" [linkUrlResolver]="getIntegratedDeliveryTrackingUrl"
                             [sortable]="false" [hideable]="true" [enabled]="false"></wbo-url-link-column>
        <wbo-date-time-column field="date"></wbo-date-time-column>
        <wbo-column field="saleType"></wbo-column>
        <wbo-column field="terminal"></wbo-column>
        <wbo-column field="employee"></wbo-column>
        <wbo-currency-column field="discount"></wbo-currency-column>
        <wbo-currency-column field="total"></wbo-currency-column>
        <wbo-currency-column field="refunds"></wbo-currency-column>
        <wbo-currency-column field="voids"></wbo-currency-column>
        <wbo-actions-search-column *ngIf="maintenanceMode">
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
